import { IEtapaPorGrupo } from "../../../Interfaces/Geral/Etapas/EtapasInterfaces";
import {
    DeletaEtapaCategoriaAtendimentoTipoCasoGrupoService,
    InsereEtapaCategoriaAtendimentoTipoCasoGrupoService,
    ListarCategoriaAtendimentoTipoCasoService,
    ListarEtapasDesvinculadasPorGrupoService,
} from "../../../Services/Repasse/EtapasCasoRepasse/InsereEtapaCategoriaAtendimentoTipoCasoGrupoServices";
import { Controller } from "../../Controller";

export async function InsereEtapaCategoriaAtendimentoTipoCasoGrupoController(
    requestBody: IEtapaPorGrupo
) {
    return Controller(
        InsereEtapaCategoriaAtendimentoTipoCasoGrupoService(requestBody)
    );
}

export async function ListarCategoriaAtendimentoTipoCasoController(
    idTipoCaso: number,
    idGrupo: number,
    idCategoriaAtendimento: number
) {
    return Controller(
        ListarCategoriaAtendimentoTipoCasoService(
            idTipoCaso,
            idGrupo,
            idCategoriaAtendimento
        )
    );
}

export async function ListarEtapasDesvinculadasPorGrupoController(
    idGrupo: number,
    idCategoriaAtendimento: number,
    idTipoCaso: number
) {
    return Controller(
        ListarEtapasDesvinculadasPorGrupoService(
            idGrupo,
            idCategoriaAtendimento,
            idTipoCaso
        )
    );
}
export async function DeletaEtapaCategoriaAtendimentoTipoCasoGrupoController(
    idEtapaCategoriaAtendimentoTipoCasoGrupo: number
) {
    return Controller(
        DeletaEtapaCategoriaAtendimentoTipoCasoGrupoService(
            idEtapaCategoriaAtendimentoTipoCasoGrupo
        )
    );
}
